<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-05-10 11:16:45
    Description : gaia图片浏览器
  -->
  <div class="gaia-viewer">
    <viewer :images="imgsList">
      <template slot-scope="scope">
        <img
          class="image"
          v-for="(src, index) in imgsList"
          v-show="index === 0"
          :src="src"
          :key="index"
        />
      </template>
    </viewer>
  </div>
</template>

<script>
import Vue from "vue";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source",
  },
});
export default {
  name: "gaia-viewer",
  props: {
    imgs: {
      type: Array,
      default: [],
    },
  },
  watch: {
    imgs(new_value, old_value) {
      if (old_value !== new_value && new_value !== this.imgsList) {
        this.imgsList = new_value.map((el) => {
          return this.VUE_APP_RESOURCES_URL + el;
        });
      }
    },
  },
  mounted() {
    this.imgsList = this.imgs;
  },
  data() {
    return {
      VUE_APP_RESOURCES_URL: process.env.VUE_APP_RESOURCES_URL,
      imgsList: [],
    };
  },
};
</script>
<style lang="less" scoped>
.gaia-viewer {
  min-height: 200px;
}
.image {
  width: 268px;
  height: 268px;
  margin: 5px;
  display: inline-block;
  cursor: pointer;
}
</style>
